module.exports = __webpack_public_path__ + "img/bg-image-32.748d2540.jpg";